import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import UserCard from '../../components/User/UserCard/UserCard';
import ListingSection from './ListingSection';
import ListingSectionItem from './ListingSectionItem';

/**
 * Render host information if author is provided
 * @param {object} props - Component props
 * @param {import('@vansite/ts-sharetribe-flex-sdk').User} props.author - Author of the listing
 * @param {import('@vansite/ts-sharetribe-flex-sdk').CurrentUser | null} props.currentUser - Currently logged in user
 * @param {function} props.getTranslation - Function to translate
 * @returns {React.JSX.Element|null}
 */

const SectionHostMaybeComponent = ({ author, currentUser = null, getTranslation }) => {
  if (!author) {
    return null;
  }

  return (
    <ListingSection>
      <ListingSectionItem params={{ size: { lg: 12 } }}>
        <Typography
          component="h3"
          mb={4}
          sx={{ textAlign: { xs: 'center', sm: 'left' }, width: '100%' }}
          variant="h4"
        >
          <FormattedMessage id="ListingPage.yourHostHeading" />
        </Typography>
      </ListingSectionItem>
      <ListingSectionItem params={{ size: { lg: 12 } }}>
        <UserCard currentUser={currentUser} getTranslation={getTranslation} user={author} />
      </ListingSectionItem>
    </ListingSection>
  );
};

SectionHostMaybeComponent.displayName = 'SectionHostMaybe';

const SectionHostMaybe = memo(SectionHostMaybeComponent);

export default SectionHostMaybe;
